import { MutationCache, QueryCache, QueryClient } from '@tanstack/query-core';
import {
  buildLoginUrl,
  currentPathWithSearchAndHash,
} from '@quoruum/frontend-common/auth/returnUrl';

function redirectToLogin(): void {
  if (window.location.pathname !== '/login') {
    window.location.replace(buildLoginUrl(currentPathWithSearchAndHash()));
  }
}

function getStatusCodeFromError(error: unknown): number | undefined {
  if (error instanceof Response) {
    return error.status;
  }

  if (typeof error === 'object' && error !== null && 'status' in error) {
    const status = (error as { status?: unknown }).status;
    if (typeof status === 'number') {
      return status;
    }
  }

  if (typeof error === 'object' && error !== null && 'response' in error) {
    const response = (error as { response?: { status?: unknown } }).response;
    if (typeof response?.status === 'number') {
      return response.status;
    }
  }

  return undefined;
}

function handleAuthError(error: unknown): void {
  const statusCode = getStatusCodeFromError(error);
  if (statusCode === 401) {
    redirectToLogin();
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      handleAuthError(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      handleAuthError(error);
    },
  }),
});
